import script from "./DuplicateTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateTitle.vue?vue&type=script&setup=true&lang=js"

import "./DuplicateTitle.vue?vue&type=style&index=0&id=68832b47&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68832b47"]])

export default __exports__